import React, { useState } from 'react'
import TrashHeavy from '@tecuity/sos-icons/react/trash-heavy'
import './CommonList.scss'

const CommonList = ({
  list,
  selectItem = (row) => {
    // console.log('Row Selected', row)
  },
  deleteItem = (row) => {
    // console.log('Row Initiated Delete', row)
  } /* export, import, */,
  handleScroll = () => {},
  allowDelete = false,
  itemTitle = 'settings',
}) => {
  const [selectedRowId, setSelectedRowId] = useState(null)
  return (
    <div className="settings-list" onScroll={handleScroll}>
      {list.length ? (
        list.find((row) => row.Name) ? (
          list.map((row) => (
            <div
              key={row.Id}
              className={`settings-list-item ${selectedRowId === row.Id ? `selected` : ``} ${
                allowDelete ? `allow-delete` : ``
              }`}
              onClick={() => {
                selectItem(row)
                setSelectedRowId(row.Id)
              }}
            >
              {row.Name ? (row.Name.trim() === '' ? '[SPACE]' : row.Name) : ''}
              {allowDelete && (
                <div className="settings-delete-button" onClick={() => deleteItem(row)}>
                  <TrashHeavy />
                </div>
              )}
            </div>
          ))
        ) : (
          <div>List out of sync, please refresh</div>
        )
      ) : (
        <div>No {itemTitle} to display</div>
      )}
    </div>
  )
}

export default CommonList
